// extracted by mini-css-extract-plugin
module.exports = {"icon-button":"modal-language-selector_icon-button__Rqn3f","modal":"modal-language-selector_modal__LIVIk"};